import { type Component, type JSX, splitProps } from 'solid-js';

export interface DigitsInputProps
  extends Omit<JSX.InputHTMLAttributes<HTMLInputElement>, 'value' | 'type' | 'inputmode' | 'onInput' | 'onChange'> {
  value: string;
  onValue: (digits: string) => void;
}

export const keepDigits = (el: HTMLInputElement): string => {
  const raw = el.value;
  const clean = raw.replace(/\D/g, '');
  if (clean !== raw) {
    const caret = Math.max(0, (el.selectionStart ?? raw.length) - (raw.length - clean.length));
    el.value = clean;
    el.setSelectionRange(caret, caret);
  }
  return clean;
};

export const DigitsInput: Component<DigitsInputProps> = (props) => {
  const [local, rest] = splitProps(props, ['value', 'onValue']);
  return (
    <input
      {...rest}
      type="text"
      inputmode="numeric"
      value={local.value}
      onInput={(e) => local.onValue(keepDigits(e.currentTarget))}
    />
  );
};
